/**
 * How an inventor came to be in a portfolio — read from the entity row's own
 * stored field, in one place.
 *
 * WHY THIS FILE EXISTS. The entity row records how the relationship began in a
 * field whose stored value is a licensing word from the platform's earlier
 * model. That value is a database fact, not a screen: the UI says "★ by
 * invitation" and never the stored word. Keeping the literal here, in lib/,
 * means no screen file has to carry it — the same treatment the backend's own
 * route names get. Screens import `cameInByInvitation` and never the constant.
 */

/** The stored `subscription_type` for an inventor the portfolio invited. */
export const INVITED_SUBSCRIPTION_TYPE = 'sponsored'

/**
 * True when this inventor is in the portfolio BY INVITATION — the portfolio
 * asked, and they accepted — rather than having granted the portfolio access
 * directly. It says how the relationship began, and nothing at all about what
 * the portfolio may see: only the inventor's grants decide that.
 */
export function cameInByInvitation(entity: { subscription_type?: string } | null | undefined): boolean {
  return entity?.subscription_type === INVITED_SUBSCRIPTION_TYPE
}

/**
 * POST /innovateflow/sponsorship/invite requires a non-empty `tier` field in
 * its body — a licensing leftover in the route's own contract. NOTHING in the
 * UI is gated on it and no screen shows it, so the invite sends this one
 * value and the portfolio is never asked to choose. If licensing is ever
 * un-deferred, this is the constant a real choice attaches to.
 */
export const INVITE_PLAN_FIELD = 'Standard'
